import { SvgIcon } from '@mui/material';

export function FilterIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 16,
    height: 16,
    color: '#0f0b11',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      sx={rootSx}
      {...rest}
    >
      <path
        d="M7.111 6A1.121 1.121 0 006 7.111v1.373A3.335 3.335 0 007.271 11.1l4.507 3.551v6.68a.667.667 0 001.054.543l3.111-2.222a.667.667 0 00.28-.543v-4.456l4.507-3.55A3.335 3.335 0 0022 8.484V7.111A1.121 1.121 0 0020.889 6zm.222 1.333h13.334v1.151a2 2 0 01-.762 1.57l-4.444 3.5h-2.922L8.1 10.055a2 2 0 01-.762-1.57zm5.778 7.556h1.778v3.879l-1.778 1.27z"
        transform="translate(-6 -6)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function AwardIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 18,
    height: 18,
    color: '#6552cc',
    ...rootStyle,
  };
  return (
    <SvgIcon
      sx={rootSx}
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M1034.59 564.21L959.198 320l-73.785 242.527H640l198.898 151.577L761.906 960l198.895-151.578L1159.7 960l-78.6-244.21L1280 564.21h-245.41z" />
        <path d="M357.542 0H1562.46v119.181H1920v423.687a423.712 423.712 0 01-124.09 299.592 423.743 423.743 0 01-237.96 119.589A423.635 423.635 0 011438.36 1200c-77.91 77.91-183.04 122.35-293.03 124.05v172.26c0 14.07 5.58 27.56 15.53 37.5a53.038 53.038 0 0037.5 15.54c64.96 0 127.25 25.8 173.18 71.73a244.93 244.93 0 0171.74 173.18V1920H476.723v-125.74a244.91 244.91 0 01244.916-244.91 53.021 53.021 0 0037.501-15.54 53.014 53.014 0 0015.534-37.5v-172.26A423.695 423.695 0 01481.637 1200a423.677 423.677 0 01-119.589-237.951A423.695 423.695 0 010 542.868V119.181h357.542V0zm132.29 132.29v768.12c0 77.283 30.701 151.4 85.348 206.05a291.39 291.39 0 00206.049 85.35h125.735v304.5c0 49.15-19.525 96.29-54.28 131.05a185.35 185.35 0 01-131.045 54.28 112.594 112.594 0 00-79.638 32.99 112.612 112.612 0 00-32.797 73.08H1310.8a112.62 112.62 0 00-32.8-73.08 112.594 112.594 0 00-79.64-32.99 185.327 185.327 0 01-185.32-185.33v-304.5h125.73a291.401 291.401 0 00291.4-291.4V132.29H489.832zm-132.29 119.181H132.29v291.397a291.4 291.4 0 00225.252 283.791V251.471zM1562.46 826.659V251.471h225.25v291.397a291.39 291.39 0 01-85.35 206.049 291.387 291.387 0 01-139.9 77.742z" />
      </g>
    </SvgIcon>
  );
}

export function DeleteCircleIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 63,
    height: 63,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 63.6 63.6"
      {...rest}
    >
      <g data-name="Group 5143">
        <path
          data-name="Path 943"
          d="M50.033 25a25.033 25.033 0 1025.033 25.033A25.033 25.033 0 0050.033 25z"
          transform="translate(-14.5 -14.5) translate(-3.266 -3.466)"
          fill="#feeaea"
        />
        <path
          data-name="Path 944"
          d="M46.3 16a30.3 30.3 0 1030.3 30.3A30.3 30.3 0 0046.3 16z"
          fill="none"
          stroke="#444b54"
          strokeWidth={3}
          transform="translate(-14.5 -14.5)"
        />
        <path
          data-name="trash-can (1)"
          d="M16.8 4a3.614 3.614 0 00-3.6 3.6H6.9a.9.9 0 100 1.8h1.5v15.3a3.3 3.3 0 003.3 3.3h10.2a3.3 3.3 0 003.3-3.3V9.4h1.5a.9.9 0 100-1.8h-6.3A3.614 3.614 0 0016.8 4zm0 1.8a1.787 1.787 0 011.8 1.8H15a1.787 1.787 0 011.8-1.8zm-2.7 6.6a.9.9 0 01.9.9v9a.9.9 0 11-1.8 0v-9a.9.9 0 01.9-.9zm5.4 0a.9.9 0 01.9.9v9a.9.9 0 01-1.8 0v-9a.9.9 0 01.9-.9z"
          transform="translate(-14.5 -14.5) translate(29.967 30.3)"
          fill="#f44f5a"
        />
      </g>
    </SvgIcon>
  );
}
export function AddIcon(props) {
  const { rootStyle, letter, ...rest } = props;

  const rootSx = {
    height: 24,
    width: 24,
    borderRadius: '100%',
    display: 'grid',
    placeItems: 'center',
    fontWeight: 600,
    color: '#EB6D13',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-add"
        d="M16,4A12,12,0,1,0,28,16,12.014,12.014,0,0,0,16,4Zm5.1,12.9H16.9v4.2a.9.9,0,0,1-1.8,0V16.9H10.9a.9.9,0,1,1,0-1.8h4.2V10.9a.9.9,0,1,1,1.8,0v4.2h4.2a.9.9,0,0,1,0,1.8Z"
        transform="translate(-4 -4)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function ViewSummaryIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 11.2,
    height: 14,
    color: '#007965',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.2 14"
      {...rest}
      sx={rootSx}
    >
      <path
        d="M9.575 4A1.577 1.577 0 008 5.575v10.85A1.577 1.577 0 009.575 18h8.05a1.577 1.577 0 001.575-1.575v-7.35a.523.523 0 00-.154-.371L14.5 4.154A.523.523 0 0014.125 4zm0 1.05H13.6v2.975A1.577 1.577 0 0015.175 9.6h2.975v6.825a.526.526 0 01-.525.525h-8.05a.524.524 0 01-.525-.525V5.575a.524.524 0 01.525-.525zm5.075.742l2.758 2.758h-2.233a.524.524 0 01-.525-.525zM10.975 11a.875.875 0 10.875.875.875.875 0 00-.875-.875zm2.45.35a.525.525 0 100 1.05h3.15a.525.525 0 100-1.05zm-2.45 2.45a.875.875 0 10.875.875.875.875 0 00-.875-.875zm2.45.35a.525.525 0 100 1.05h3.15a.525.525 0 100-1.05z"
        transform="translate(-8 -4)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function BillIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 13.466,
    height: 14.4,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.466 14.4"
      sx={rootSx}
      {...rest}
    >
      <g data-name="Group 5800">
        <path
          d="M8.525 5A.516.516 0 008 5.516v10.659a1.9 1.9 0 001.891 1.891h7.221A1.9 1.9 0 0019 16.175V5.516a.516.516 0 00-.725-.471l-1.348.6-1.517-.607a.516.516 0 00-.383 0l-1.527.61-1.528-.611a.516.516 0 00-.383 0l-1.517.607-1.349-.6A.516.516 0 008.525 5zm3.257 1.071l1.528.611a.516.516 0 00.383 0l1.528-.611 1.528.611a.516.516 0 00.4-.007l.822-.365v9.865a.852.852 0 01-.86.86h-7.22a.852.852 0 01-.86-.86V6.309l.822.365a.516.516 0 00.4.007zm-1.2 3.055a.516.516 0 100 1.032h5.845a.516.516 0 100-1.032zm0 3.095a.516.516 0 100 1.032h3.095a.516.516 0 100-1.032zm5.158 0a.516.516 0 100 1.032h.688a.516.516 0 100-1.032zm-5.158 2.063a.516.516 0 100 1.032h3.095a.516.516 0 100-1.032zm5.158 0a.516.516 0 100 1.032h.688a.516.516 0 100-1.032z"
          transform="translate(-219 -416) translate(211 411)"
          fill="#007965"
        />
        <g
          data-name="Group 5772"
          transform="translate(-219 -416) translate(222.74 420.673)"
        >
          <circle
            data-name="Ellipse 39514"
            cx={4.663}
            cy={4.663}
            r={4.663}
            fill="#fff"
          />
          <g fill="#007965">
            <path
              d="M28.663 33.526a4.834 4.834 0 01-3.443-1.42 4.834 4.834 0 01-1.42-3.443c0-1.304.504-2.527 1.42-3.443a4.834 4.834 0 013.443-1.42c1.304 0 2.527.504 3.443 1.42a4.834 4.834 0 011.42 3.443 4.834 4.834 0 01-1.42 3.443 4.834 4.834 0 01-3.443 1.42zm-2.12-4.663a.264.264 0 00-.154.07.21.21 0 000 .31l2.12 2.119a.218.218 0 00.154.068c.057 0 .11-.023.155-.068l2.12-2.12a.21.21 0 000-.31.218.218 0 00-.155-.069.218.218 0 00-.155.07l-1.4 1.398-.34.34V25.697c0-.145-.08-.224-.225-.224-.144 0-.224.08-.224.224v4.976l-.341-.341-1.4-1.399a.264.264 0 00-.154-.069z"
              transform="translate(-24 -24)"
            />
            <path
              d="M28.663 24A4.65 4.65 0 0024 28.663a4.65 4.65 0 004.663 4.663 4.65 4.65 0 004.663-4.663A4.65 4.65 0 0028.663 24m.424 6.19l1.4-1.4c.169-.169.423-.169.592 0 .17.17.17.424 0 .593l-2.12 2.12a.409.409 0 01-.592 0l-2.12-2.12a.409.409 0 010-.592.458.458 0 01.297-.128c.084 0 .211.043.296.128l1.4 1.398v-4.493c0-.255.169-.424.423-.424.255 0 .424.17.424.424v4.493m-.424-6.589c1.358 0 2.63.525 3.584 1.479a5.033 5.033 0 011.48 3.584c0 1.358-.526 2.63-1.48 3.584a5.033 5.033 0 01-3.584 1.48 5.033 5.033 0 01-3.584-1.48 5.033 5.033 0 01-1.479-3.584c0-1.357.525-2.63 1.479-3.584a5.033 5.033 0 013.584-1.479zm.022 2.074a.18.18 0 00-.044 0 .122.122 0 00-.002.022v5.458l-2.082-2.08a.068.068 0 00-.013-.007.068.068 0 00-.015.008.034.034 0 00-.01.013l.011.013 2.12 2.12c.008.007.013.01.014.01l.013-.01 2.12-2.12a.037.037 0 00.01-.014s-.003-.006-.01-.013a.038.038 0 00-.015-.01s-.005.002-.013.01l-2.082 2.08v-5.458c0-.01 0-.018-.002-.022z"
              fill="#fff"
              transform="translate(-24 -24)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function BodyCamera(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 15.998,
    width: 16,
    color: '#184457',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={12.644}
      height={16}
      viewBox="0 0 12.644 16"
      {...props}
      sx={rootSx}
      {...rest}
    >
      <path
        d="M12.166 5a3.184 3.184 0 00-3.191 3.248l.28 9.684A3.185 3.185 0 0012.447 21h5.695a3.187 3.187 0 003.193-3.067l.28-9.684v-.046a.632.632 0 000-.153A3.187 3.187 0 0018.423 5zm0 1.263h6.257a1.9 1.9 0 011.926 1.9l-.187 1.863a1.887 1.887 0 01-1.885 1.706h-5.954a1.887 1.887 0 01-1.885-1.706L10.245 8.1a1.9 1.9 0 011.921-1.837zM15.3 7.947a1.263 1.263 0 101.263 1.263A1.263 1.263 0 0015.3 7.947zm-4.945 4.358a3.145 3.145 0 001.968.695h5.954a3.143 3.143 0 001.956-.686l-.156 5.373a5.045 5.045 0 00-9.565.029zm4.945 3.221a3.78 3.78 0 013.789 3.789.632.632 0 00.019.161 1.948 1.948 0 01-.967.26h-5.694a1.948 1.948 0 01-.956-.254.632.632 0 00.021-.167 3.78 3.78 0 013.788-3.789z"
        transform="translate(-8.973 -5)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function CalenderPlusIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 24,
    width: 24,
    color: 'primary.main',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14.2"
      height="14.2"
      viewBox="0 0 14.2 14.2"
      stroke="#007965"
      strokeWidth="0.2"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-calendar-plus"
        d="M8.27,6A2.274,2.274,0,0,0,6,8.273v8.044a2.274,2.274,0,0,0,2.27,2.273h4.035a4.524,4.524,0,0,1-.5-1.049H8.27a1.224,1.224,0,0,1-1.222-1.224V9.847H17.523v1.971a4.5,4.5,0,0,1,1.048.5V8.273A2.274,2.274,0,0,0,16.3,6Zm0,1.049H16.3a1.224,1.224,0,0,1,1.222,1.224V8.8H7.048V8.273A1.224,1.224,0,0,1,8.27,7.049Zm1.048,4.2a.874.874,0,1,0,.873.874.874.874,0,0,0-.873-.874Zm2.968,0a.874.874,0,1,0,.873.874A.874.874,0,0,0,12.285,11.246Zm3.874,1.059A3.847,3.847,0,1,0,20,16.153,3.844,3.844,0,0,0,16.159,12.306Zm0,1.049a.35.35,0,0,1,.349.35v2.1h2.1a.35.35,0,0,1,0,.7h-2.1v2.1a.349.349,0,1,1-.7,0V16.5h-2.1a.35.35,0,0,1,0-.7h2.1V13.7A.35.35,0,0,1,16.159,13.355ZM9.317,14.394a.874.874,0,1,0,.873.874A.874.874,0,0,0,9.317,14.394Z"
        transform="translate(-5.9 -5.9)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function LockIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 12,
    width: 9.6,
    stroke: '#5C6266',
    strokeWidth: '0.4',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="12.4"
      viewBox="0 0 10 12.4"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-lock_1_"
        data-name="icons8-lock (1)"
        d="M12.8,4a2.407,2.407,0,0,0-2.4,2.4V7.6H9.35A1.357,1.357,0,0,0,8,8.95v5.7A1.357,1.357,0,0,0,9.35,16h6.9a1.357,1.357,0,0,0,1.35-1.35V8.95A1.357,1.357,0,0,0,16.25,7.6H15.2V6.4A2.407,2.407,0,0,0,12.8,4Zm0,.9a1.493,1.493,0,0,1,1.5,1.5V7.6h-3V6.4A1.493,1.493,0,0,1,12.8,4.9ZM9.35,8.5h6.9a.443.443,0,0,1,.45.45v5.7a.443.443,0,0,1-.45.45H9.35a.443.443,0,0,1-.45-.45V8.95A.443.443,0,0,1,9.35,8.5Zm3.45,2.4a.9.9,0,1,0,.9.9A.9.9,0,0,0,12.8,10.9Z"
        transform="translate(-7.8 -3.8)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function ProfilePlusIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 14,
    width: 14,
    stroke: '#5C6266',
    strokeWidth: '0.2',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="14.041"
      height="14.2"
      viewBox="0 0 14.041 14.2"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-add-user-male_1_"
        data-name="icons8-add-user-male (1)"
        d="M7.114,2A3.182,3.182,0,1,0,10.3,5.182,3.189,3.189,0,0,0,7.114,2Zm0,.955A2.227,2.227,0,1,1,4.886,5.182,2.22,2.22,0,0,1,7.114,2.955ZM12.841,9a3.5,3.5,0,1,0,3.5,3.5A3.5,3.5,0,0,0,12.841,9Zm-9.156.636A1.229,1.229,0,0,0,2.5,10.9v.484a2.955,2.955,0,0,0,1.519,2.554,5.98,5.98,0,0,0,3.094.787,6.74,6.74,0,0,0,2.061-.315,4.116,4.116,0,0,1-.339-.894,5.821,5.821,0,0,1-1.723.254c-1.762,0-3.659-.747-3.659-2.386V10.9c0-.169.106-.311.23-.311H9.174a4.143,4.143,0,0,1,.687-.955Zm9.156.318a.318.318,0,0,1,.318.318v1.909h1.909a.318.318,0,1,1,0,.636H13.159v1.909a.318.318,0,0,1-.636,0V12.818H10.614a.318.318,0,1,1,0-.636h1.909V10.273A.318.318,0,0,1,12.841,9.955Z"
        transform="translate(-2.4 -1.9)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function LogoutConfirmIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 60.6,
    width: 60.6,
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="63.6"
      height="63.6"
      viewBox="0 0 63.6 63.6"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Logout_confirmation"
        data-name="Logout confirmation"
        transform="translate(-14.5 -14.5)"
      >
        <path
          id="Path_943"
          data-name="Path 943"
          d="M50.033,25A25.033,25.033,0,1,0,75.066,50.033,25.033,25.033,0,0,0,50.033,25Z"
          transform="translate(-3.266 -3.466)"
          fill="#fae6e7"
        />
        <path
          id="Path_944"
          data-name="Path 944"
          d="M46.3,16A30.3,30.3,0,1,0,76.6,46.3,30.3,30.3,0,0,0,46.3,16Z"
          fill="none"
          stroke="#444b54"
          strokeWidth="3"
        />
        <path
          id="icons8-logout"
          d="M9.972,6A3.989,3.989,0,0,0,6,9.972V28.028A3.989,3.989,0,0,0,9.972,32h13a3.989,3.989,0,0,0,3.972-3.972,1.083,1.083,0,1,0-2.167,0,1.789,1.789,0,0,1-1.805,1.806h-13a1.79,1.79,0,0,1-1.806-1.806V9.972A1.79,1.79,0,0,1,9.972,8.167h13a1.79,1.79,0,0,1,1.806,1.806,1.083,1.083,0,1,0,2.167,0A3.989,3.989,0,0,0,22.972,6ZM25.85,12.85A1.083,1.083,0,0,0,25.1,14.71L28.3,17.917H12.861a1.083,1.083,0,1,0,0,2.167H28.3L25.1,23.29a1.083,1.083,0,1,0,1.532,1.532l5.056-5.056a1.083,1.083,0,0,0,0-1.532l-5.056-5.056a1.083,1.083,0,0,0-.777-.329Z"
          transform="translate(28 27.8)"
          fill="#444b54"
        />
      </g>
    </SvgIcon>
  );
}
export function ShareIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 60.6,
    width: 60.6,
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="63.6"
      height="63.6"
      viewBox="0 0 63.6 63.6"
      sx={rootSx}
      {...rest}
    >
      <g
        id="Group_5143"
        data-name="Group 5143"
        transform="translate(-14.5 -14.5)"
      >
        <path
          id="Path_943"
          data-name="Path 943"
          d="M50.033,25A25.033,25.033,0,1,0,75.066,50.033,25.033,25.033,0,0,0,50.033,25Z"
          transform="translate(-3.266 -3.466)"
          fill="#e1f5f2"
        />
        <path
          id="Path_944"
          data-name="Path 944"
          d="M46.3,16A30.3,30.3,0,1,0,76.6,46.3,30.3,30.3,0,0,0,46.3,16Z"
          fill="none"
          stroke="#444b54"
          strokeWidth="3"
        />
        <path
          id="icons8-share"
          d="M26.211,5a4.805,4.805,0,0,0-4.789,4.789,4.569,4.569,0,0,0,.23,1.132l-8.2,4.1a4.715,4.715,0,0,0-3.658-1.815,4.789,4.789,0,0,0,0,9.579,4.715,4.715,0,0,0,3.658-1.815l8.2,4.1a4.569,4.569,0,0,0-.23,1.132,4.789,4.789,0,1,0,4.789-4.789,4.715,4.715,0,0,0-3.658,1.815l-8.2-4.1A4.569,4.569,0,0,0,14.579,18a4.569,4.569,0,0,0-.23-1.132l8.2-4.1a4.715,4.715,0,0,0,3.658,1.815,4.789,4.789,0,0,0,0-9.579Zm0,2.053a2.737,2.737,0,1,1-2.737,2.737A2.721,2.721,0,0,1,26.211,7.053ZM9.789,15.263A2.737,2.737,0,1,1,7.053,18,2.721,2.721,0,0,1,9.789,15.263Zm16.421,8.211a2.737,2.737,0,1,1-2.737,2.737A2.721,2.721,0,0,1,26.211,23.474Z"
          transform="translate(28 28.8)"
          fill="#444b54"
        />
      </g>
    </SvgIcon>
  );
}
export function CheckMark(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 12,
    width: 12,
    stroke: '#f5faf9',
    strokeWidth: '1.5',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="8.516"
      height="6.566"
      viewBox="0 0 8.516 6.566"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-checkmark"
        d="M9.656,8.98a.333.333,0,0,0-.229.1L5.332,13.175,3.568,11.412a.333.333,0,1,0-.471.471l2,2a.333.333,0,0,0,.471,0L9.9,9.552a.333.333,0,0,0-.242-.572Z"
        transform="translate(-2.25 -8.229)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function ConnectIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 12,
    width: 12,
    strokeWidth: '0.25',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="19.25"
      viewBox="0 0 19.25 19.25"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-connect"
        d="M20.5,5a3.494,3.494,0,0,0-2.707,5.711L15.387,13.75h-3.47a3.5,3.5,0,1,0,0,1.5h3.47l2.406,3.039a3.535,3.535,0,1,0,1.177-.93L16.707,14.5l2.263-2.859A3.459,3.459,0,0,0,20.5,12a3.5,3.5,0,0,0,0-7Zm0,1.5a2,2,0,1,1-2,2A1.989,1.989,0,0,1,20.5,6.5Zm-12,6a2,2,0,1,1-2,2A1.989,1.989,0,0,1,8.5,12.5Zm12,6a2,2,0,1,1-2,2A1.989,1.989,0,0,1,20.5,18.5Z"
        transform="translate(-4.875 -4.875)"
        fill="currentColor"
        stroke="currentColor"
      />
    </SvgIcon>
  );
}

export function StethoscopeIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: '100px',
    width: '100px',
    color: '#abcdc8',
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 75.434 72.434"
      {...rest}
    >
      <path
        data-name="icons8-stethoscope (1)"
        d="M18.462 2a8.238 8.238 0 00-7.54 4.945A9.089 9.089 0 002 15.993a18.369 18.369 0 005.379 12.986l-.074-.079L22.52 45.48c.043.066.076.134.122.2a2.47 2.47 0 00.7.691L25.7 48.94a2.47 2.47 0 001.016.682c.1 6.647 1.519 12.606 4.524 17.125a16.77 16.77 0 0014.247 7.688c10.554 0 18.643-7.76 20.658-18.395a10.694 10.694 0 00-2.408-21.115 10.6 10.6 0 00-8.019 3.4 11.274 11.274 0 000 14.6 10.182 10.182 0 005.376 3.1c-1.89 8.258-7.683 13.472-15.607 13.472a11.324 11.324 0 01-10.135-5.482c-2.273-3.418-3.6-8.471-3.7-14.4a2.469 2.469 0 00.978-.669l2.434-2.653a2.47 2.47 0 00.62-.6c.048-.068.081-.14.125-.209L51.02 28.9l-.074.077a18.369 18.369 0 005.379-12.987 9.092 9.092 0 00-9.054-9.054h-1.518a8.222 8.222 0 10.527 4.939h.99a4.079 4.079 0 014.116 4.116 13.423 13.423 0 01-3.932 9.495q-.038.038-.074.077L35.333 38.689A5.543 5.543 0 0031 36.571h-3.67a5.541 5.541 0 00-4.337 2.119L10.945 25.565q-.036-.039-.074-.077a13.424 13.424 0 01-3.932-9.495 4.06 4.06 0 013.476-4.051A8.229 8.229 0 1018.462 2zm0 4.939a3.292 3.292 0 11-3.292 3.292 3.292 3.292 0 013.292-3.292zm19.755 0a3.292 3.292 0 11-3.292 3.292 3.292 3.292 0 013.292-3.292zm25.516 32.924a5.762 5.762 0 110 11.524 5.345 5.345 0 01-4.328-1.743 6.349 6.349 0 010-8.038 5.345 5.345 0 014.328-1.743zm-36.4 1.646H31c.719 0 1.024.5.772 1.067l-2.6 2.836-2.608-2.839c-.258-.573.049-1.064.766-1.064zm36.4 1.646a2.469 2.469 0 102.467 2.47 2.469 2.469 0 00-2.467-2.47z"
        transform="translate(-2 -2)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function ProfessionalInfoIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: '15px',
    width: '13px',
    color: '#abcdc8',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={rootSx}
      viewBox="0 0 15.205 13.823"
      {...rest}
    >
      <path
        d="M7.22 2a2.073 2.073 0 00-2.073 2.073H3.073A2.073 2.073 0 001 6.147v7.6a2.073 2.073 0 002.073 2.073h11.059a2.073 2.073 0 002.073-2.073v-7.6a2.073 2.073 0 00-2.073-2.073h-2.074A2.073 2.073 0 009.985 2zm0 1.382h2.765a.691.691 0 01.691.691H6.529a.691.691 0 01.691-.691zm.691 5.529h1.383v1.9l5.529-1.658v4.6a.691.691 0 01-.691.691H3.073a.691.691 0 01-.691-.691v-4.6l5.529 1.658zm0 1.9v.869h1.383v-.869l-.493.148a.689.689 0 01-.4 0z"
        transform="translate(-1 -2)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
export function LockPassword(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 12,
    width: 12,
    strokeWidth: '0.15',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="15.7"
      height="19.5"
      viewBox="0 0 15.7 19.5"
      sx={rootSx}
      {...rest}
    >
      <path
        id="icons8-password"
        d="M15.6,4a3.811,3.811,0,0,0-3.8,3.8V9.7H10.138A2.148,2.148,0,0,0,8,11.837v9.025A2.148,2.148,0,0,0,10.138,23H21.063A2.148,2.148,0,0,0,23.2,20.862V11.837A2.148,2.148,0,0,0,21.063,9.7H19.4V7.8A3.811,3.811,0,0,0,15.6,4Zm0,1.425A2.364,2.364,0,0,1,17.975,7.8V9.7h-4.75V7.8A2.364,2.364,0,0,1,15.6,5.425Zm-5.462,5.7H21.063a.7.7,0,0,1,.712.712v9.025a.7.7,0,0,1-.712.713H10.138a.7.7,0,0,1-.713-.713V11.837A.7.7,0,0,1,10.138,11.125ZM12.275,15.4a.95.95,0,1,0,.95.95A.95.95,0,0,0,12.275,15.4Zm3.325,0a.95.95,0,1,0,.95.95A.95.95,0,0,0,15.6,15.4Zm3.325,0a.95.95,0,1,0,.95.95A.95.95,0,0,0,18.925,15.4Z"
        transform="translate(-7.75 -3.75)"
        fill="currentColor"
        stroke="currentColor"
      />
    </SvgIcon>
  );
}
export function PulseIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 40,
    height: 41,
    ...rootStyle,
  };
  return (
    <SvgIcon
      data-name="Group 5615"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 41"
      sx={rootSx}
      {...rest}
    >
      <g
        data-name="Rectangle 44700"
        fill="#e6fff9"
        stroke="#d3f5ed"
        strokeWidth={1}
      >
        <rect width={40} height={41} rx={4} stroke="none" />
        <rect x={0.5} y={0.5} width={39} height={40} rx={3.5} fill="none" />
      </g>
      <path
        d="M12.267 6a.591.591 0 00-.594.474l-1.511 7.556-.889-2.889a.591.591 0 00-1.107-.059l-1.027 2.4H4.771a.984.984 0 100 1.181h2.757a.591.591 0 00.543-.358l.548-1.277 1.1 3.58a.591.591 0 001.143-.058l1.3-6.5 1.473 10.017a.591.591 0 001.157.057l1.463-5.852h1.508a.984.984 0 100-1.181H15.8a.591.591 0 00-.573.448l-.851 3.406-1.539-10.44a.591.591 0 00-.57-.5z"
        transform="translate(8.732 7.215)"
        fill="#45c6a6"
      />
    </SvgIcon>
  );
}
export function BmiNoBgIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16.6,
    width: 16.6,
    color: 'rgba(24,87,76,0.48)',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.6 16.6"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Path 4861" fill="currentColor">
        <path
          d="M3.016 2A1.046 1.046 0 002 3.067v13.866A1.046 1.046 0 003.016 18h13.206a1.046 1.046 0 001.016-1.067v-2.438A1.06 1.06 0 0018 13.467v-1.6a1.06 1.06 0 00-.762-1.028V3.067A1.046 1.046 0 0016.222 2zm0 .533h13.206a.515.515 0 01.508.533V10.8h-.469a.245.245 0 00-.043 0H14.991a.245.245 0 00-.043 0H13.721a.245.245 0 00-.043 0H12.451a.245.245 0 00-.043 0H11.181a.245.245 0 00-.043 0H9.912a.245.245 0 00-.043 0H8.642a.245.245 0 00-.043 0H7.373a.244.244 0 00-.043 0H4.286a.248.248 0 00-.18.078.274.274 0 00-.074.189v3.2a.274.274 0 00.074.189.248.248 0 00.18.078H16.73v2.4a.515.515 0 01-.508.533H3.016a.515.515 0 01-.508-.533V3.067a.515.515 0 01.508-.534zm6.6 1.6a.242.242 0 00-.048.006 4.33 4.33 0 00-2.7.851 2.89 2.89 0 00-.773.894.279.279 0 00-.01.213l.762 2.133a.265.265 0 00.093.125.246.246 0 00.145.048h5.079a.246.246 0 00.145-.048.265.265 0 00.093-.125l.762-2.133a.279.279 0 00-.01-.213 2.891 2.891 0 00-.773-.894 4.33 4.33 0 00-2.7-.851.243.243 0 00-.066-.009zm-.25.547v.79a.28.28 0 00.018.1.269.269 0 00.055.088.255.255 0 00.083.059.243.243 0 00.2 0 .253.253 0 00.078-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-.79a4.21 4.21 0 011.49.32l-.207.653a.278.278 0 00-.012.1.276.276 0 00.026.1.265.265 0 00.061.082.251.251 0 00.086.052.243.243 0 00.194-.014.256.256 0 00.078-.064.271.271 0 00.049-.09l.184-.578c.09.057.174.116.248.174a2.093 2.093 0 01.568.618l-.655 1.835h-1.814l.2-1.249a.279.279 0 00.01-.124.274.274 0 00-.045-.115.257.257 0 00-.09-.081.244.244 0 00-.115-.029.248.248 0 00-.18.078.273.273 0 00-.074.189l-.637 1.33H7.255L6.6 6.032a2.093 2.093 0 01.568-.618 3.08 3.08 0 01.249-.174l.184.578a.27.27 0 00.049.09.256.256 0 00.078.064.243.243 0 00.194.014.251.251 0 00.086-.052.266.266 0 00.061-.082.279.279 0 00.014-.2L7.875 5a4.21 4.21 0 011.49-.323zM3.27 5.733A.267.267 0 103.524 6a.261.261 0 00-.254-.267zm1.016 0A.267.267 0 104.54 6a.261.261 0 00-.254-.267zm1.016 0A.267.267 0 105.556 6a.261.261 0 00-.256-.267zm8.635 0A.267.267 0 1014.19 6a.261.261 0 00-.254-.267zm1.016 0a.267.267 0 10.253.267.261.261 0 00-.254-.267zm1.016 0a.267.267 0 10.253.267.261.261 0 00-.254-.267zm-11.429 5.6h.76v.8a.274.274 0 00.074.189.248.248 0 00.18.078.267.267 0 010 .533.248.248 0 00-.18.078.274.274 0 00-.074.189v.8h-.76zm1.27 0h1.27V12.4a.278.278 0 00.018.1.269.269 0 00.055.088.255.255 0 00.083.059.243.243 0 00.2 0 .255.255 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-1.067h.762v.533a.278.278 0 00.018.1.269.269 0 00.055.088.254.254 0 00.083.059.243.243 0 00.2 0 .255.255 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-.533h.762V12.4a.278.278 0 00.018.1.269.269 0 00.055.088.255.255 0 00.083.059.243.243 0 00.2 0 .256.256 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-1.067h.762v.533a.278.278 0 00.018.1.269.269 0 00.055.088.254.254 0 00.083.059.243.243 0 00.2 0 .255.255 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-.533h.762V12.4a.278.278 0 00.018.1.269.269 0 00.055.088.255.255 0 00.083.059.243.243 0 00.2 0 .256.256 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-1.067h.762v.533a.278.278 0 00.018.1.269.269 0 00.055.088.254.254 0 00.083.059.243.243 0 00.2 0 .255.255 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-.533h.738V12.4a.278.278 0 00.018.1.269.269 0 00.055.088.255.255 0 00.083.059.243.243 0 00.2 0 .256.256 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-1.067h.762v.533a.278.278 0 00.018.1.269.269 0 00.055.088.254.254 0 00.083.059.243.243 0 00.2 0 .255.255 0 00.083-.059.269.269 0 00.055-.088.278.278 0 00.018-.1v-.533h.508a.517.517 0 01.508.533v1.6a.517.517 0 01-.508.533H5.81v-.644a.721.721 0 000-1.378z"
          transform="translate(-3.7 -2.7) translate(2 1)"
        />
        <path
          d="M3.016 2C2.458 2 2 2.48 2 3.067v13.866C2 17.52 2.458 18 3.016 18h13.206c.558 0 1.016-.48 1.016-1.067v-2.438A1.06 1.06 0 0018 13.467v-1.6a1.06 1.06 0 00-.762-1.028V3.067C17.238 2.48 16.78 2 16.222 2H3.016m13.714 8.8h-.469a.247.247 0 00-.08 0h-1.19a.248.248 0 00-.08 0h-1.19a.247.247 0 00-.08 0h-1.19a.247.247 0 00-.079 0h-1.19a.248.248 0 00-.08 0h-1.19a.248.248 0 00-.08 0h-1.19a.246.246 0 00-.08 0h-1.19a.246.246 0 00-.08 0H4.287a.248.248 0 00-.18.078.274.274 0 00-.074.189v3.2c0 .07.027.138.074.188.048.05.112.078.18.078H16.73v2.4c0 .3-.223.534-.508.534H3.016a.515.515 0 01-.508-.534V3.067c0-.3.223-.534.508-.534h13.206c.285 0 .508.234.508.534V10.8M5.302 14H4.54v-2.667h.762v.8c0 .071.026.139.074.189.048.05.112.078.18.078.143 0 .254.116.254.267 0 .15-.11.266-.254.266a.248.248 0 00-.18.078.274.274 0 00-.074.189v.8m2.031-1.33a.244.244 0 00.181-.079.269.269 0 00.073-.191v-1.067h.762v.534a.278.278 0 00.073.19.246.246 0 00.362 0 .27.27 0 00.073-.19v-.534h.762V12.4a.278.278 0 00.073.191.246.246 0 00.362 0 .27.27 0 00.073-.191v-1.067h.762v.534a.278.278 0 00.073.19.246.246 0 00.362 0 .27.27 0 00.073-.19v-.534h.762V12.4a.278.278 0 00.073.191.246.246 0 00.362 0 .27.27 0 00.073-.191v-1.067h.762v.534a.278.278 0 00.073.19.246.246 0 00.362 0 .27.27 0 00.072-.19v-.534h.762V12.4a.278.278 0 00.074.191.246.246 0 00.362 0 .27.27 0 00.072-.191v-1.067h.762v.534a.278.278 0 00.073.19.246.246 0 00.362 0 .27.27 0 00.073-.19v-.534h.508c.284 0 .508.236.508.534v1.6a.517.517 0 01-.508.533H5.81v-.644c.28-.118.507-.354.507-.69 0-.334-.226-.57-.507-.688v-.645h1.27V12.4a.278.278 0 00.072.191.255.255 0 00.181.08M9.617 4.13a.23.23 0 00-.05.005c-1.29.012-2.162.425-2.703.851-.549.432-.774.895-.774.895a.277.277 0 00-.01.213l.762 2.133c.018.05.05.095.093.125.042.031.093.048.144.048h5.08a.246.246 0 00.144-.048.265.265 0 00.093-.125l.762-2.133a.278.278 0 00-.01-.213s-.225-.463-.774-.895c-.54-.426-1.413-.84-2.704-.85a.243.243 0 00-.053-.006m.002 1.607a.243.243 0 00.18-.08.269.269 0 00.074-.19v-.79c.613.028 1.104.152 1.49.32l-.207.652a.278.278 0 00.074.286.251.251 0 00.185.065.245.245 0 00.174-.092.271.271 0 00.049-.09l.183-.578c.09.057.175.115.249.174.372.293.512.518.568.618l-.655 1.835h-1.814l.199-1.25a.28.28 0 00-.036-.24.25.25 0 00-.385-.033.273.273 0 00-.074.19l-.635 1.333H7.255L6.6 6.032c.056-.1.196-.325.568-.618.074-.059.159-.117.249-.174l.183.578a.27.27 0 00.128.154.245.245 0 00.28-.037.266.266 0 00.087-.183.28.28 0 00-.013-.103l-.207-.653c.386-.167.877-.291 1.49-.32v.79a.28.28 0 00.073.192.254.254 0 00.181.08m-6.35-.005c-.139 0-.253.12-.253.267 0 .147.114.267.254.267s.254-.12.254-.267a.261.261 0 00-.254-.267m1.016 0c-.14 0-.254.12-.254.267 0 .147.114.267.254.267s.254-.12.254-.267a.261.261 0 00-.254-.267m1.016 0c-.14 0-.254.12-.254.267 0 .147.114.267.254.267s.254-.12.254-.267a.261.261 0 00-.254-.267m8.634 0c-.14 0-.253.12-.253.267 0 .147.114.267.253.267.14 0 .254-.12.254-.267a.261.261 0 00-.254-.267m1.016 0c-.14 0-.254.12-.254.267 0 .147.115.267.254.267.14 0 .254-.12.254-.267a.261.261 0 00-.254-.267m1.016 0c-.14 0-.254.12-.254.267 0 .147.115.267.254.267.14 0 .254-.12.254-.267a.261.261 0 00-.254-.267M3.016 1.7h13.206c.726 0 1.316.613 1.316 1.367v7.565c.458.221.762.7.762 1.235v1.6a1.37 1.37 0 01-.762 1.234v2.232c0 .754-.59 1.367-1.316 1.367H3.016c-.726 0-1.316-.613-1.316-1.367V3.067c0-.754.59-1.367 1.316-1.367zM16.43 5.687v-2.62c0-.133-.09-.234-.208-.234H3.016c-.119 0-.208.1-.208.234v2.62a.55.55 0 01.462-.254c.227 0 .422.14.508.34.085-.2.28-.34.508-.34.227 0 .422.14.508.34.085-.2.28-.34.508-.34.226 0 .422.14.507.34a.582.582 0 01.01-.021c.012-.024.263-.532.859-1.001.518-.408 1.435-.897 2.861-.915a.543.543 0 01.07-.006h.008c.027 0 .054.002.08.006 1.428.018 2.345.506 2.863.915.596.469.847.977.858.999a.618.618 0 01.01.024c.086-.2.282-.34.508-.34.227 0 .423.14.508.34.086-.2.281-.34.508-.34.227 0 .423.14.508.34.086-.2.281-.34.508-.34a.55.55 0 01.462.253zm-6.811.35a.54.54 0 01-.4-.174.567.567 0 01-.154-.4V5c-.294.033-.568.091-.818.175l.121.383a.577.577 0 01-.158.599.549.549 0 01-.896-.249l-.057-.18c-.136.117-.245.23-.325.341l.535 1.498h1.582l.53-1.113a.568.568 0 01.151-.316.55.55 0 01.655-.106.56.56 0 01.29.418.583.583 0 01-.014.232l-.14.885h1.25l.535-1.498a2 2 0 00-.325-.34l-.057.18a.568.568 0 01-.274.329.542.542 0 01-.622-.081.563.563 0 01-.184-.385.575.575 0 01.026-.214l.122-.383A3.93 3.93 0 0010.173 5v.467a.57.57 0 01-.336.524.54.54 0 01-.218.046zm6.35.53a.555.555 0 01-.509-.34.555.555 0 01-.508.34.555.555 0 01-.508-.34.555.555 0 01-.508.34.555.555 0 01-.507-.34l-.75 2.101a.563.563 0 01-.199.267.543.543 0 01-.321.105h-5.08a.543.543 0 01-.32-.105.563.563 0 01-.2-.267l-.75-2.1a.555.555 0 01-.507.339.555.555 0 01-.508-.34.555.555 0 01-.508.34.555.555 0 01-.508-.34.555.555 0 01-.508.34.55.55 0 01-.462-.254v10.62c0 .133.09.234.208.234h13.206c.119 0 .208-.1.208-.234v-2.1H4.286a.551.551 0 01-.397-.17.57.57 0 01-.157-.396v-3.2a.57.57 0 01.157-.396.551.551 0 01.397-.171h2.986a.55.55 0 01.05-.004h.007c.022 0 .043.002.064.004h1.148a.552.552 0 01.05-.004H8.6c.022 0 .043.002.064.004h1.148a.552.552 0 01.05-.004h.008c.022 0 .043.002.064.004h1.148a.552.552 0 01.05-.004h.008c.022 0 .043.002.064.004h1.148a.552.552 0 01.05-.004h.008c.021 0 .043.002.064.004h1.148a.552.552 0 01.05-.004h.008c.021 0 .042.002.064.004h1.148a.552.552 0 01.05-.004h.007c.022 0 .043.002.064.004h1.148a.552.552 0 01.05-.004h.008c.022 0 .043.002.064.004h.148V6.313a.55.55 0 01-.462.254zM5.001 11.633H4.84V13.7h.162v-.5a.57.57 0 01.367-.533.571.571 0 01-.368-.533v-.5zm1.777 0h-.67v.162c.322.198.508.513.508.872 0 .358-.186.673-.507.871v.162h10.874c.117 0 .208-.103.208-.233v-1.6c0-.131-.091-.234-.208-.234h-.208v.234a.569.569 0 01-.335.524.545.545 0 01-.619-.128.567.567 0 01-.154-.4v-.23h-.162v.767a.57.57 0 01-.335.524.545.545 0 01-.618-.128.567.567 0 01-.155-.4v-.763h-.162v.234a.569.569 0 01-.334.524.545.545 0 01-.62-.128.567.567 0 01-.153-.4v-.23h-.162v.767a.57.57 0 01-.335.524.545.545 0 01-.619-.128.567.567 0 01-.154-.4v-.763h-.162v.234a.569.569 0 01-.335.524.545.545 0 01-.619-.128.567.567 0 01-.154-.4v-.23h-.162v.767a.57.57 0 01-.335.524.545.545 0 01-.618-.128.567.567 0 01-.155-.4v-.763h-.162v.234a.569.569 0 01-.335.524.545.545 0 01-.619-.128.565.565 0 01-.154-.4v-.23h-.162v.767a.57.57 0 01-.335.524.545.545 0 01-.618-.127.567.567 0 01-.155-.401v-.763z"
          transform="translate(-3.7 -2.7) translate(2 1)"
        />
      </g>
    </SvgIcon>
  );
}
export function CalenderIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 16,
    width: 16,
    color: '#5C6266',
    ...rootStyle,
  };

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      {...rest}
      sx={rootSx}
    >
      <path
        id="icons8-calendar"
        d="M8.167,6A2.174,2.174,0,0,0,6,8.167v7.667A2.174,2.174,0,0,0,8.167,18h7.667A2.174,2.174,0,0,0,18,15.833V8.167A2.174,2.174,0,0,0,15.833,6Zm0,1h7.667A1.159,1.159,0,0,1,17,8.167v.5H7v-.5A1.159,1.159,0,0,1,8.167,7ZM7,9.667H17v6.167A1.159,1.159,0,0,1,15.833,17H8.167A1.159,1.159,0,0,1,7,15.833ZM9.167,11a.833.833,0,1,0,.833.833A.833.833,0,0,0,9.167,11ZM12,11a.833.833,0,1,0,.833.833A.833.833,0,0,0,12,11Zm2.833,0a.833.833,0,1,0,.833.833A.833.833,0,0,0,14.833,11ZM9.167,14a.833.833,0,1,0,.833.833A.833.833,0,0,0,9.167,14ZM12,14a.833.833,0,1,0,.833.833A.833.833,0,0,0,12,14Z"
        transform="translate(-6 -6)"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export function Waves(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    height: 274,
    width: 362,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={340}
      height={260}
      viewBox="0 0 340 260"
      sx={rootSx}
      {...rest}
    >
      <defs>
        <clipPath id="a">
          <rect
            data-name="Rectangle 55790"
            width={340}
            height={260}
            rx={8}
            transform="translate(3775 5263)"
            fill="#ebfaf7"
          />
        </clipPath>
      </defs>
      <g
        data-name="Mask Group 30"
        transform="translate(-3775 -5263)"
        clipPath="url(#a)"
      >
        <path
          data-name="Path 101050"
          d="M4246.2 5374.776s43.9-13.3 108.7 32.61 83.672 74.509 130.442 66.356 72.945-35.186 79.81-90.967 43.338-50.632 43.338-50.632l2.574 220.121-375.45 4.291 2.574-160.907 6.476-10.4z"
          transform="translate(-478 -51)"
          fill="#d2e8e4"
        />
        <path
          data-name="Path 101049"
          d="M4246.2 5382.776s43.9-13.3 108.7 32.61 83.672 66.509 130.442 58.356 72.945-35.186 79.81-90.967 43.338-50.632 43.338-50.632l2.574 220.121-375.45 4.291 2.574-160.907z"
          transform="translate(-478 -30)"
          fill="#c8e5e1"
        />
      </g>
    </SvgIcon>
  );
}
